import { render, staticRenderFns } from "./nbn-check-list-details-wireless.vue?vue&type=template&id=4daf1850&scoped=true"
import script from "./nbn-check-list-details-wireless.vue?vue&type=script&lang=js"
export * from "./nbn-check-list-details-wireless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf1850",
  null
  
)

export default component.exports